const ITEM_WIDTH = 96; // w-24 — mobile baseline, conservative for worst-case coverage
const GAP = 12; // gap-3
const MAX_VIEWPORT = 2560;

export const expandForInfiniteCarousel = (logos: string[]): string[] => {
  if (logos.length === 0) return [];
  const contribPerLogo = ITEM_WIDTH + GAP;
  const minCount = Math.ceil(MAX_VIEWPORT / contribPerLogo);
  const reps = Math.max(1, Math.ceil(minCount / logos.length));
  return Array.from({ length: reps }, () => logos).flat();
};
